import { Component } from '@angular/core';

@Component({
  selector: 'logibids-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {}
